import React from "react";

const PropertyRules = (rules) => {
  return (
    <div className="row mt-2">
      <div className="col-12">
        <div className="propertyruldlt">
          <h4>Property Rules</h4>

          <div className="mb-3">
                    <div className="d-flex justify-content-between border-bottom py-2">
                      <span className="fw-semibold">Check-in</span>
                      <span>{rules?.rules?.check_in || "Not specified"}</span>
                    </div>

                    <div className="d-flex justify-content-between py-2">
                      <span className="fw-semibold">Check-out</span>
                      <span>{rules?.rules?.check_out || "Not specified"}</span>
                    </div>
                  </div>
          <div className="mb-3">
            <h4 className="mb-2">House Rules & Policies</h4>

            {rules?.rules?.cancellation_policy ? (
              <div className="policy-list">
                {rules?.rules?.cancellation_policy
                  .split(",")
                  .map((rule, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-start mb-2"
                    >
                      <span className="me-2 text-primary">•</span>
                      <span>{rule.trim()}</span>
                    </div>
                  ))}
              </div>
            ) : (
              <p className="text-muted mb-0">
                No cancellation policy available
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyRules;
